export default __webpack_public_path__ + "static/media/av8.3214b62e.jpg";